import { useEffect, useState } from "react";
import { api, fmtXof } from "../lib/api";

const WA_GREEN = "#25D366";

export function WhatsAppIcon({ size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
    </svg>
  );
}

function waUrl(text, number = "") {
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}

function trackShare(product_id, kind) {
  api.post("/share", { product_id, kind }).catch(() => {});
}

export function ShareProductButton({ product }) {
  const url = `${window.location.origin}/produit/${product.product_id}`;
  const desc = product.description || "";
  const short = desc.length > 120 ? desc.slice(0, 120) + "…" : desc;
  const msg = `Bonjour ! J'ai trouvé cette formation sur Vitalis Digital Store — Cabinet CARIS Santé :
📚 ${product.title}
💰 ${fmtXof(product.price)}
📝 ${short}
👉 Voir la formation : ${url}
Formation dispensée par Cabinet CARIS Santé — Abidjan, Côte d'Ivoire 🇨🇮`;
  return (
    <a
      href={waUrl(msg)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackShare(product.product_id, "product")}
      data-testid="whatsapp-share-btn"
      className="mt-3 flex w-full items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold text-white transition-all duration-200 hover:brightness-110"
      style={{ backgroundColor: WA_GREEN }}
    >
      <WhatsAppIcon size={17} /> Partager sur WhatsApp
    </a>
  );
}

export function ShareCartButton({ items, total }) {
  const lines = items.map((i) => `- ${i.title} : ${fmtXof(i.price * i.qty)}`).join("\n");
  const msg = `Bonjour ! Voici les formations que je recommande sur Vitalis Digital Store :
${lines}
Total : ${fmtXof(total)}
👉 Accéder à la boutique : ${window.location.origin}`;
  return (
    <a
      href={waUrl(msg)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackShare(null, "cart")}
      data-testid="whatsapp-share-cart"
      className="mt-3 flex w-full items-center justify-center gap-2 rounded-full border-2 px-5 py-3 text-sm font-semibold transition-colors duration-200 hover:text-white"
      style={{ borderColor: WA_GREEN, color: WA_GREEN }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = WA_GREEN, e.currentTarget.style.color = "#fff")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent", e.currentTarget.style.color = WA_GREEN)}
    >
      <WhatsAppIcon size={17} /> Partager mon panier sur WhatsApp
    </a>
  );
}

export function FloatingWhatsApp() {
  const [number, setNumber] = useState("");
  useEffect(() => {
    api.get("/config").then(({ data }) => setNumber(data.whatsapp_number || "")).catch(() => {});
  }, []);
  // Masqué en mode présentation vidéo plein écran (patient et médecin)
  if (typeof window !== "undefined" && (window.location.pathname.startsWith("/visio/") || window.location.pathname.startsWith("/admin/visio/consultation/"))) return null;
  const msg = "Bonjour Cabinet CARIS Santé, j'ai une question concernant vos formations.";
  return (
    <a
      href={waUrl(msg, number)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Nous contacter sur WhatsApp"
      className="group fixed bottom-24 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full text-white shadow-lg transition-transform duration-200 hover:scale-110"
      style={{ backgroundColor: WA_GREEN }}
    >
      <span className="absolute inset-0 animate-ping rounded-full opacity-20" style={{ backgroundColor: WA_GREEN }} />
      <WhatsAppIcon size={26} />
    </a>
  );
}
